import HotlistStorage from "../decorators/hotlist-storage"
import Utils from "../utils/utilities"
import { getHotlistId } from "../utils/window-utils"
import Singleton from "../decorators/singleton"
import EditList from "./editing"
import OnEvent from "../decorators/on-event"
import ListService from "../services/list-service"
import FixedTabs from './fixed-tabs'
import BindClass from "../decorators/bind-to-class"
import BindToList from "../decorators/bind-to-list"
import ListingHelpers from "../helpers/listing-helpers"
import ErrorHandlers from "./error-handlers"
import DomUtils from "../utils/dom-utils"
import UpdateSubscription from "./update-subscription"
import TrackingService from "../services/tracking-service"
import { asArray } from "../../../../bower_components/pattern-library-v2/src/ts/utilities/utils"

const HIDE: string = 'hide'
const ARE_YOU_SURE: string = 'are-you-sure'

export default class ListEntrance {

    @BindToList
    private listEntries: Array<any>

    @BindClass(HIDE)
    private blankList: boolean = true

    @BindClass(HIDE)
    private hideList: boolean = true

    @BindClass('cloak')
    private bodyCloak: boolean = true

    @HotlistStorage
    private hotlistStorage: any

    @Singleton
    private editing: EditList

    @Singleton
    private fixedTabs: FixedTabs

    @Singleton
    private errorHandler: ErrorHandlers

    @Singleton
    private updateSubscription: UpdateSubscription

    public init(): void {
        if (Utils.isDefined(this.hotlistStorage)) {
            const id: string = getHotlistId()

            this.bodyCloak = false

            ListService.getCurrentList().then((res: any) => {
                this.hotlistStorage.id = id
                this.hotlistStorage.name = res.list.name

                this.hotlistStorage.lists.forEach(list => list.active = false)
                this.hotlistStorage.lists = {
                    name: res.list.name,
                    id: id,
                    active: true
                }

                this.fixedTabs.updateFixedTabs()
                this.editing.updateListName(this.hotlistStorage.name)

                if (Utils.isDefined(res.updates) && Utils.isDefined(res.updates.socket)) {
                    this.updateSubscription.subscribeToWebSocket(res.updates.socket, res.updates.subscription)
                }

                if (Utils.isNotEmpty(res.list.items)) {
                    this.listEntries = ListingHelpers.processLists(res.list.items)
                    this.hideList = false
                    this.listenForRemove()
                } else {
                    this.hideList = true
                    this.blankList = false
                }

                DomUtils.unCloak()

                setTimeout(() => {
                    const viewButtons: HTMLAnchorElement[] = asArray(document.querySelectorAll('[view-entry]'))
                    viewButtons.forEach((viewButton: HTMLAnchorElement, index: number) => {
                        viewButton.addEventListener('click', () => {
                            TrackingService.trackEvent('WISHLIST_VIEW_CLICK', [ this.listEntries[index], this.listEntries, index ])
                        })
                    })
                })
            }).catch(e => {
                switch(e.status) {
                    case 404:
                        this.errorHandler.handle404Errors(id)
                        break
                    default:
                        this.errorHandler.handle500Errors(id)
                        break
                }
            })
        }
    }

    private listenForRemove(): void {
        Utils.asArray(document.querySelectorAll('[list-entry]')).forEach(entry => {
            entry.querySelector(`[${ARE_YOU_SURE}]`).addEventListener('click', () => entry.classList.add(ARE_YOU_SURE))
            entry.querySelector(`[cancel-${ARE_YOU_SURE}]`).addEventListener('click', () => entry.classList.remove(ARE_YOU_SURE))
        })

        Utils.asArray(document.querySelectorAll('[data-hotlist-remove]')).forEach(entry => {
            entry.addEventListener('click', (event: MouseEvent) => {
                if (Utils.isDefined(event.target) &&
                    Utils.isDefined((event.target as HTMLElement).dataset &&
                    Utils.isDefined((event.target as HTMLElement).dataset.hotlistRemove))) {
                        const hotlistRemoveLink: string = (event.target as HTMLElement).dataset.hotlistRemove
                        TrackingService.trackEvent('REMOVING_ITEM_FROM_WISHLIST', [this.hotlistStorage.name, hotlistRemoveLink])
                        ListService.removeItem(hotlistRemoveLink)
                            .then(() => {
                                this.init()
                                TrackingService.trackEvent('REMOVED_ITEM_FROM_WISHLIST', [this.hotlistStorage.name, hotlistRemoveLink])
                            })
                            .catch(() => this.errorHandler.removeListErrorState())
                }
            })
        })
    }

    @OnEvent({
        selector: '[create-new-list]'
    })
    private createNewList(): void {
        ListService.createNewList()
            .then(id => location.href = `/hotlist/${id}`)
    }
}